import axios from '../utils/axios'

export function getStudentsInfo() {
  return axios.get('/getStudents');
}

export function createStudent(data) {
  // data: { picurl, grade, email, name, reaserch_type, next_plan, paper, intern }
  return axios.post('/createStudent', data)
}

export function updateStudent(id, data) {
  // data: { picurl, grade, email, name, reaserch_type, next_plan, paper, intern }
  return axios.post(`/updateStudent/${id}`, data)
}

